import { ref } from "@vue/composition-api";

const conversationsExportStatus = ref();
const conversationsExportFileUrl = ref();

export default function useConversationExports() {
    return {
        conversationsExportStatus,
        conversationsExportFileUrl,
    };
}
